import { AlertVariant } from './types';

export const styles = {
  base: 'tw-rounded tw-border tw-p-4 tw-flex tw-items-start tw-gap-3',

  variants: {
    error: 'tw-bg-danger-50 tw-border-danger-200 tw-text-danger-700',
    warning: 'tw-bg-warning-50 tw-border-warning-200 tw-text-warning-700',
    success: 'tw-bg-success-50 tw-border-success-200 tw-text-success-700',
  } as Record<AlertVariant, string>,

  icon: 'tw-flex-shrink-0 tw-w-5 tw-h-5',

  content: 'tw-flex-1 tw-text-sm',

  dismissButton: 'tw-flex-shrink-0 tw-ml-auto tw--mr-1 tw--mt-1',
};
